export enum OnboardStepsAction {
  STEP_1 = '1',
  STEP_2 = '2',
  STEP_3 = '3',
}
